/**
 * IonToast — the transient "Ion is ready" cue shown near the launcher FAB when
 * Ion finishes a turn while the chat is minimized. Self-gating on the
 * chatToastVisible signal; auto-dismisses (timer in chatStore) but clicking the
 * body restores the chat and the × dismisses just the toast (the FAB badge
 * stays until the chat is opened).
 */

import { chatToastVisible, restoreChat, dismissToast } from '../../state/chatStore.js'
import { IconIonBolt, IconX } from '../shared/Icons.jsx'
import { t } from '../../i18n/index.js'

export function IonToast() {
  if (!chatToastVisible.value) return null

  return (
    <div class="ion-toast" role="status" aria-live="polite" onClick={restoreChat}>
      <IconIonBolt size={14} className="ion-toast__bolt" />
      <span class="ion-toast__label">{t('ion.toast.ready')}</span>
      <button
        type="button"
        class="ion-toast__close"
        aria-label={t('ion.toast.dismiss')}
        onClick={(e) => {
          e.stopPropagation()
          dismissToast()
        }}
      >
        <IconX size={14} />
      </button>
    </div>
  )
}
